import { ref } from 'vue'
import type { ToastItem } from '@/components/Toast.vue'

// Global toast state
const toasts = ref<ToastItem[]>([])

export const useToast = () => {
  const addToast = (toast: Omit<ToastItem, 'id'>) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9)
    const newToast: ToastItem = {
      id,
      duration: 5000,
      closable: true,
      ...toast
    }
    
    toasts.value.push(newToast)
    
    if (newToast.duration && newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, newToast.duration)
    }
    
    return id
  }

  const removeToast = (id: string) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearToasts = () => {
    toasts.value = []
  }

  const showSuccess = (message: string, options?: Partial<ToastItem>) => {
    return addToast({ type: 'success', message, ...options })
  }

  const showError = (message: string, options?: Partial<ToastItem>) => {
    return addToast({ type: 'error', message, ...options })
  }

  const showWarning = (message: string, options?: Partial<ToastItem>) => {
    return addToast({ type: 'warning', message, ...options })
  }

  const showInfo = (message: string, options?: Partial<ToastItem>) => {
    return addToast({ type: 'info', message, ...options })
  }

  return {
    toasts,
    addToast,
    removeToast,
    clearToasts,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}

// Export global state for Toast component
export { toasts }









